import React, {useState} from "react";
import SelectDropdown from "../Components/Dropdowns/SelectDropdown";
import ProjectionsUpload from "./Components/ProjectionsUpload";
import VersionSelect from "./Components/VersionSelect";
import UploadTemplateHelp from "./Components/UploadTemplateHelp";
import {uploadTemplates} from "./uploadTemplates";
import {CELL_TARGET_UNIVERSE_OPTIONS, cellTargetUniverseParam} from "./cellTargets";

const ProjectionCellTargetsUpload = () => {
    const [loadingCSV, setLoadingCSV] = useState(false)

    const universeOptions = CELL_TARGET_UNIVERSE_OPTIONS;
    const [universeName, setUniverseName] = useState(undefined);
    const [version, setVersion] = useState("");

    return (
        <>
            {!loadingCSV &&
                <div className={'projection-upload-trigger-dag-page-controls'}>
                    <div className={'projection-upload-select-container'}>
                        <SelectDropdown id={'cell_targets_universe_dropdown'}
                                        inputLabel={"Universe"}
                                        options={universeOptions}
                                        onChange={(e) => setUniverseName(e.value)}
                                        selectValue={universeName}
                                        selectLabel={universeOptions?.find(option => option.value === universeName)?.label}
                        />
                    </div>
                    <div className={'projection-upload-select-container'}>
                        <VersionSelect version={version} setVersion={setVersion} restrictToAvailableVersions />
                    </div>
                    <ProjectionsUpload
                        getUploadUrl={() => `${process.env.REACT_APP_EDP_API_BASE_URL}/uploadCellTargets`}
                        getUploadAdditionalData={() => ({universe: cellTargetUniverseParam(universeName), version: version.trim()})}
                        setLoading={setLoadingCSV}
                        setDisabled={!universeName || !version.trim()}
                        accepts={['.csv']}
                        buttonLabel={'Upload CSV'}
                    />
                    <UploadTemplateHelp template={uploadTemplates.cellTargets}/>
                </div>
            }
        </>
    )
}

export default ProjectionCellTargetsUpload;
